<template>
	<JBox class="s-text-md s-border s-bg-white s-border-gray-300 s-rounded" style="min-height: 40rem;">
		<JFlex class="s-justify-between s-border-b s-border-gray-300 s-text-gray-700">
			<div class="font-bold s-p-4">{{ $t("core.name") }}</div>
			<div class="font-bold s-p-4">{{ $t("core.provider") }}</div>
		</JFlex>
		<JFlex
			v-for="b in buckets"
			:key="b.bucketName"
			class="s-justify-between s-font-medium s-cursor-pointer s-text-gray-900 hover:s-bg-indigo-100"
			@click="$emit('loadFileListing', b.bucketName)"
		>
			<div class="s-p-4">{{ b.bucketName }}</div>
			<div class="s-p-4">{{ b.providerId }}</div>
		</JFlex>
	</JBox>
</template>

<script>
import api from "@/api/api"
import { query } from "../../api/queries"

export default {
	data() {
		return {
			isLoading: null,
			buckets: []
		}
	},
	methods: {
		async fetchBucket() {
			this.isLoading = true
			const res = await api({ query: query.fileBuckets })
			this.isLoading = false
			this.buckets = res?.data?.fileBuckets
		}
	},

	created() {
		this.fetchBucket()
	}
}
</script>
